import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Chip,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLocation, useNavigate } from "react-router-dom";

import {
  useAddLinkage,
  useGetAllLinkage,
  useGetAttticProduct,
  useGetConfigCollectionData,
  useGetProjectList,
  useGetShopifyProductVariant,
  useGetShowcase,
  useGetShowcaseData,
  useGetValidate,
  useLinkConfigurator,
  useSyncConfiguratorLinkageById,
  useSyncLinkageById,
} from "../services/authService";
import { useProject } from "../modules/ProjectContext";

import AddLinkIcon from "@mui/icons-material/AddLink";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ProjectDetails() {
  const { selectedProject } = useProject();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogRow, setDialogRow] = useState(null);
  const params = new URLSearchParams(window.location.search);
  const shop = params.get("shop");
  const projectId = params.get("project_id");
  const projectName = params.get("project_name");

  const { data: showcaseData } = useGetShowcase(projectId);
  const { data: showcaseListData } = useGetShowcaseData(projectId);
  const { data: attticDataAll } = useGetAttticProduct(projectId);
  const attticData = attticDataAll?.data;

  const { mutate: addLinkage } = useAddLinkage();
  const { mutate: syncById } = useSyncLinkageById();
  const { mutate: linkConfig } = useLinkConfigurator();
  const { data: configCollectionList } = useGetConfigCollectionData();
  console.log("configCollectionList", configCollectionList?.data);

  const storefrontList = configCollectionList?.data?.storefronts || [];
  console.log("storefrontList", storefrontList);

  const [prefilledLinks, setPrefilledLinks] = useState({});

  const { mutate: configSyncById } = useSyncConfiguratorLinkageById();

  const showcaseList = showcaseListData?.data;
  console.log("showcaseList", showcaseList);
  const navigate = useNavigate();

  const [selectedProductId, setSelectedProductId] = useState("");
  console.log("selectedProductId", selectedProductId);
  const [selectedVariants, setSelectedVariants] = useState({});
  console.log("selectedVariants", selectedVariants);

  const handleVariantChange = (propertyId, value) => {
    setSelectedVariants((prev) => ({
      ...prev,
      [propertyId]: value,
    }));
  };

  const selectedProduct = attticData?.find(
    (p) => p.product_id === selectedProductId
  );

  // 🔑 Handle auth/shopify validation
  function useHashParams() {
    const { hash } = useLocation();
    return new URLSearchParams(hash.replace(/^#/, ""));
  }
  function useQueryParams() {
    const { search } = useLocation();
    return new URLSearchParams(search);
  }
  const hashParams = useHashParams();
  const queryParams = useQueryParams();
  const shopNameFromProject = queryParams.get("shop");

  const linkToken = hashParams.get("linkToken");
  const token = queryParams.get("token");
  const shopifyLinkToken = sessionStorage.getItem("shopifyToken");
  const authToken = sessionStorage.getItem("authToken");
  console.log("shopifyLinkTokeninside", shopifyLinkToken);
  const { data: userData } = useGetValidate(shopifyLinkToken);
  const shopName = userData?.data?.shop?.shop;

  // Shopify + linkage data
  const { data: shopifyProductVariantData } = useGetShopifyProductVariant(
    shopNameFromProject || shopName
  );
  const { data: allLinkageData } = useGetAllLinkage(
    shopNameFromProject || shopName
  );
  const projectAllLinakgeData = allLinkageData?.data;
  const shopifyProductVariantDataList = shopifyProductVariantData?.data || [];
  const [openSyncDialog, setOpenSyncDialog] = useState(false);
  const [syncRow, setSyncRow] = useState(null);
  console.log("syncRow", syncRow);

  // Product + Variants dialog

  const [selectedShowcase, setSelectedShowcase] = useState("");
  console.log("selectedShowcase", selectedShowcase);
  const [selectedStorefronts, setSelectedStorefronts] = useState({});

  // Sync Showcase dialog (separate)
  const [syncShowcase, setSyncShowcase] = useState("");
  const [syncMetaField, setSyncMetaField] = useState("");

  // const handleMetaFieldChange = (e) => {
  //   const value = e.target.value.replace(/[^a-zA-Z0-9_]/g, "");
  //   setMetaField(value);
  // };

  const handleSync = (product, variant) => {
    const matchedLinkage = projectAllLinakgeData?.find(
      (link) => String(link.shopify_variant_id) === String(variant.id)
    );

    const showcase =
      matchedLinkage?.experiences?.find((ex) => ex.type === "showcase")
        ?.atttic_experience_id || selectedShowcase;

    const productId = matchedLinkage?.atttic_product_id || selectedProductId;

    const variantMap =
      matchedLinkage?.map?.reduce((acc, m) => {
        acc[m.atttic_property_id] = m.atttic_variant_id;
        return acc;
      }, {}) || selectedVariants;

    const metafieldObj = {
      showcase,
      product: productId,
      meta: {
        property: Object.entries(variantMap).map(([propertyId, variantId]) => ({
          property_id: propertyId,
          variant_id: variantId,
        })),
      },
    };

    const encodedMeta = encodeURIComponent(JSON.stringify(metafieldObj));

    const syncPayload = {
      shop: shopName || shopNameFromProject,
      shopify_product_id: product?.id,
      shopify_variant_id: variant?.id,
      meta: encodedMeta,
      showcase_id: showcase,
    };
    console.log("syncPayload", syncPayload);

    syncById(syncPayload);
  };

  const handleConfigSync = (product, variant) => {
    const selectedUrlId = selectedStorefronts[variant.id];

    const syncConfigPayload = {
      shop: shopName || shopNameFromProject,
      shopify_product_id: product?.id,
      shopify_variant_id: variant?.id,
      url: selectedUrlId,
    };

    console.log("⚙️ Config Sync Payload:", syncConfigPayload);

    configSyncById(syncConfigPayload);
  };

  const handleLinkageChange = (product, variant, storefrontUrl) => {
    if (!product || !variant || !storefrontUrl) return;

    setSelectedStorefronts((prev) => ({
      ...prev,
      [variant.id]: storefrontUrl,
    }));

    const payload = {
      shopify_product_id: product?.id,
      shopify_variant_id: variant?.id,
      shop: shopNameFromProject || shopName,
      url: storefrontUrl,
      project_id: projectId,
    };

    linkConfig(payload);
  };

  // 🧹 Reset dialog fields
  const resetDialogFields = () => {
    setSelectedProductId("");
    setSelectedVariants({});
    setSelectedShowcase("");
    setSyncShowcase("");
    setDialogRow(null);
  };

  // Search state
  const [search, setSearch] = useState("");

  // Dialog open
  const handleOpenDialog = (product, variant, linkedData) => {
    resetDialogFields();

    setDialogRow({ product, variant });

    // Find matching linkage by variant_id
    const matchedLinkage = projectAllLinakgeData?.find(
      (link) => String(link.shopify_variant_id) === String(variant.id)
    );

    if (matchedLinkage) {
      // Prefill product
      setSelectedProductId(matchedLinkage.atttic_product_id);

      // Prefill variants mapping
      const prefillVariants = {};
      matchedLinkage.map?.forEach((m) => {
        prefillVariants[m.atttic_property_id] = m.atttic_variant_id;
      });
      setSelectedVariants(prefillVariants);

      // Prefill showcase if available
      const showcaseFromLinked = matchedLinkage.experiences?.find(
        (ex) => ex.type === "showcase"
      )?.atttic_experience_id;

      if (showcaseFromLinked) {
        setSelectedShowcase(showcaseFromLinked);
        setSyncShowcase(showcaseFromLinked);
      }
    }

    // Keep existing manual prefill logic for `linkedData` if passed
    if (linkedData && !matchedLinkage) {
      setSelectedProductId(linkedData.atttic_product_id);
      const prefillVariants = {};
      linkedData.map?.forEach((m) => {
        prefillVariants[m.atttic_property_id] = m.atttic_variant_id;
      });
      setSelectedVariants(prefillVariants);

      const showcaseFromLinked = linkedData.experiences?.find(
        (ex) => ex.type === "showcase"
      )?.id;
      if (showcaseFromLinked) {
        setSelectedShowcase(showcaseFromLinked);
        setSyncShowcase(showcaseFromLinked);
      }
    }

    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    resetDialogFields();
    setOpenDialog(false);
  };

  // const handleSync = (product, variant) => {
  //   const syncPayload = {
  //     shop: shopName,
  //     shopify_product_id: product?.id,
  //     shopify_variant_id: variant?.id,
  //     meta: product?.meta || "config",
  //   };
  //   syncById(syncPayload);
  // };

  const handleSave = () => {
    if (!dialogRow || !selectedProduct) return;

    const payload = {
      shop: shopNameFromProject,
      shopify_product_id: dialogRow.product.id,
      shopify_variant_id: dialogRow.variant.id,
      atttic_product_id: selectedProduct.product_id,
      map: Object.entries(selectedVariants).map(([propertyId, variantId]) => ({
        atttic_property_id: propertyId,
        atttic_variant_id: variantId,
      })),
      experiences: selectedShowcase
        ? [
            {
              type: "showcase",
              atttic_experience_id: selectedShowcase,
            },
          ]
        : [],
    };

    addLinkage(payload, {
      onSuccess: () => handleCloseDialog(),
      onError: (err) => console.error("Save linkage failed:", err),
    });
  };

  useEffect(() => {
    if (!storefrontList?.length) return;

    const linkMap = {};
    storefrontList.forEach((sf) => {
      sf.configurators?.forEach((conf) => {
        if (conf.shopify_variant_id) {
          linkMap[String(conf.shopify_variant_id)] = sf.url_id;
        }
      });
    });

    setPrefilledLinks(linkMap);
  }, [storefrontList]);

  const [configSyncMap, setConfigSyncMap] = useState({});

  useEffect(() => {
    if (!storefrontList?.length) return;

    const syncMap = {};
    storefrontList.forEach((sf) => {
      sf.configurators?.forEach((conf) => {
        if (conf.shopify_variant_id) {
          syncMap[String(conf.shopify_variant_id)] = conf.is_synced;
        }
      });
    });

    setConfigSyncMap(syncMap);
  }, [storefrontList]);

  // Build rows for DataGrid
  const rows =
    shopifyProductVariantDataList?.flatMap((product) =>
      product.variants.map((variant) => {
        const variantImage =
          product.images.find((img) => img.id === variant.image_id)?.src ||
          product.images[0]?.src ||
          "https://via.placeholder.com/60";

        const linkedData = projectAllLinakgeData?.find(
          (link) => link?.shopify_variant_id === String(variant?.id)
        );

        return {
          id: variant.id,
          productTitle: product.title,
          variantTitle: variant.title,
          variantImage,
          status: linkedData ? "Linked" : "Not Linked",
          is_synced: linkedData?.is_synced ?? null,
          linkedData,
          product,
          variant,
        };
      })
    ) || [];

  const filteredRows = rows.filter(
    (row) =>
      row.productTitle.toLowerCase().includes(search.toLowerCase()) ||
      row.variantTitle.toLowerCase().includes(search.toLowerCase()) ||
      String(row.id).includes(search)
  );

  const columns = [
    {
      field: "productTitle",
      headerName: "Product (Shopify)",
      flex: 0.8,
    },
    {
      field: "variantTitle",
      headerName: "Shopify Variant (id + name + image)",
      flex: 1.2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Avatar
            src={params.row.variantImage}
            variant="square"
            sx={{ width: 40, height: 40 }}
          />
          <Typography variant="body2">
            {params.row.id} – {params.row.variantTitle}
          </Typography>
        </Box>
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   renderCell: (params) =>
    //     params.value === "Linked" ? (
    //       <Chip
    //         label="Linked"
    //         sx={{
    //           backgroundColor: "#d1f2eb",
    //           color: "#0e6655",
    //           fontWeight: 600,
    //         }}
    //       />
    //     ) : (
    //       <Chip
    //         label="Not Linked"
    //         sx={{
    //           backgroundColor: "#f9e79f",
    //           color: "#7d6608",
    //           fontWeight: 600,
    //         }}
    //       />
    //     ),
    // },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.7,
      sortable: false,
      renderCell: (params) =>
        params.row.linkedData ? (
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              size="small"
              variant="contained"
              onClick={() =>
                handleOpenDialog(
                  params.row.product,
                  params.row.variant,
                  params.row.linkedData
                )
              }
            >
              <EditIcon fontSize="small" />
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{
                backgroundColor: params.row.linkedData?.is_synced
                  ? "#27ae60"
                  : "#c0392b",
              }}
              onClick={() => handleSync(params.row.product, params.row.variant)}
            >
              <SyncIcon fontSize="small" />
            </Button>
          </Box>
        ) : (
          <Button
            size="small"
            variant="contained"
            sx={{ backgroundColor: "#0a3d62" }}
            onClick={() =>
              handleOpenDialog(params.row.product, params.row.variant)
            }
          >
            <AddLinkIcon fontSize="small" />
          </Button>
        ),
    },

    {
      field: "config_linkage",
      headerName: "Linkage",
      flex: 1,
      renderHeader: () => (
        <Box sx={{ textAlign: "center", fontWeight: 700 }}>Linkage</Box>
      ),
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {params.row.linkedData
            ? params.row.linkedData?.atttic_product_id
            : "—"}
        </Typography>
      ),
    },
    {
      field: "linkage_dropdown",
      headerName: "Linkage",
      flex: 1.2,
      renderHeader: () => (
        <Box sx={{ textAlign: "center", fontWeight: 700 }}>
          Configurator Link
        </Box>
      ),
      renderCell: (params) => {
        const variantId = String(params.row.variant.id);

        // ✅ Prefill from three sources (priority order)
        const prefilledValue =
          selectedStorefronts[variantId] || // user selected manually
          prefilledLinks[variantId] || // from get_collections_list (your hook)
          "";

        return (
          <Select
            fullWidth
            size="small"
            value={prefilledValue}
            onChange={(e) =>
              handleLinkageChange(
                params.row.product,
                params.row.variant,
                e.target.value
              )
            }
            displayEmpty
            sx={{ minWidth: 160 }}
          >
            <MenuItem value="">
              <em>Select Storefront</em>
            </MenuItem>

            {storefrontList?.map((sf) => (
              <MenuItem key={sf._id} value={sf.url_id}>
                {sf.url_id}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "config_action",
      headerName: "Action",
      flex: 1,
      renderHeader: () => (
        <Box sx={{ textAlign: "center", fontWeight: 700 }}>Action</Box>
      ),
      renderCell: (params) => {
        const variantId = String(params.row.variant.id);
        const isSynced = configSyncMap[variantId];
        return (
          <Button
            size="small"
            variant="contained"
            sx={{
              backgroundColor: isSynced ? "#27ae60" : "#c0392b",
              "&:hover": {
                backgroundColor: isSynced ? "#219150" : "#922b21",
              },
            }}
            onClick={() =>
              handleConfigSync(params.row.product, params.row.variant)
            }
          >
            <SyncIcon fontSize="small" />
          </Button>
        );
      },
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        {projectName}
      </Typography>

      {/* 🔎 Search */}
      <Box style={{ margin: "10px 0px" }}>
        <TextField
          fullWidth
          placeholder="Search products or variants..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>

      <Box sx={{ position: "relative", height: 632, width: "100%" }}>
        {/* 🔹 Dynamic grouped header row */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            display: "flex",
            backgroundColor: "#0a3d62",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            borderBottom: "1px solid #ccc",
            height: 35,
            alignItems: "center",
          }}
        >
          {/* Shopify group (Product + Variant + Actions) */}
          <Box
            sx={{
              flex: 1.26, // total of product(1.2) + variant(1.2) + action(1)
              borderRight: "1px solid #ccc",
            }}
          >
            Shopify
          </Box>

          {/* Showcase group (Linkage + Configurator Link) */}
          <Box
            sx={{
              flex: 1.07, // total of those two flex values
              borderRight: "1px solid #ccc",
            }}
          >
            Showcase
          </Box>

          {/* Configurator group (Action) */}
          <Box sx={{ flex: 1.39 }}>Configurator</Box>
        </Box>

        {/* 🔹 Actual DataGrid */}
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          disableSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[10, 25, 50]}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f8f9fa",
              color: "#000",
              fontWeight: "bold",
              borderTop: "none",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 600,
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid #e0e0e0",
            },
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid #e0e0e0",
            },
          }}
        />
      </Box>

      {/* Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {dialogRow
            ? `${dialogRow.product.title} — ${dialogRow.variant.title}`
            : "View Variants"}
        </DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          {/* Product select */}
          <Select
            value={selectedProductId}
            onChange={(e) => {
              setSelectedProductId(e.target.value);
              setSelectedVariants({});
              setSelectedShowcase("");
            }}
            fullWidth
            displayEmpty
            disabled={Boolean(selectedShowcase)}
          >
            <MenuItem value="" disabled>
              Select Product
            </MenuItem>
            {attticData?.map((product) => (
              <MenuItem key={product.product_id} value={product.product_id}>
                {product.product_id}
              </MenuItem>
            ))}
          </Select>

          {selectedProduct ? (
            <Box
              sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
              {selectedProduct.property.length === 0 ? (
                <Typography>No properties available</Typography>
              ) : (
                selectedProduct.property.map((prop) => (
                  <Box
                    key={prop.property_id}
                    sx={{ display: "flex", alignItems: "center", gap: 2 }}
                  >
                    <Typography sx={{ minWidth: 100 }}>
                      {prop.display_name}
                    </Typography>
                    <Select
                      value={selectedVariants[prop.property_id] || ""}
                      onChange={(e) =>
                        handleVariantChange(prop.property_id, e.target.value)
                      }
                      fullWidth
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Variant
                      </MenuItem>
                      {prop.variants.map((variant) => (
                        <MenuItem
                          key={variant.variant_id}
                          value={variant.variant_id}
                        >
                          {variant?.variant_name || variant?.variant_id}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                ))
              )}
            </Box>
          ) : (
            <Typography sx={{ mt: 2 }}>
              Please select a product to see variants
            </Typography>
          )}

          {showcaseList && selectedProductId ? (
            <Box sx={{ mt: 1 }}>
              <Typography>Select Showcase</Typography>

              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <Select
                  value={selectedShowcase}
                  onChange={(e) => {
                    setSelectedShowcase(e.target.value);
                    setSyncShowcase(e.target.value);
                  }}
                  fullWidth
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Showcase
                  </MenuItem>
                  {showcaseList
                    .filter((sc) =>
                      selectedProduct
                        ? sc.products.some(
                            (p) => p.product === selectedProduct._id
                          )
                        : true
                    )
                    .map((sc) => (
                      <MenuItem key={sc.showcase_id} value={sc.showcase_id}>
                        {sc.showcase_name}
                      </MenuItem>
                    ))}
                </Select>

                {selectedShowcase && (
                  <Button
                    onClick={() => {
                      setSelectedShowcase("");
                      setSyncShowcase("");
                    }}
                    color="error"
                    variant="outlined"
                  >
                    <DeleteIcon />
                  </Button>
                )}
              </Box>
            </Box>
          ) : (
            <Typography>No showcases found for this product</Typography>
          )}

          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
